import { CKEditor5 } from "src/components/CKEditor5/CKEditor5.tsx";
import { setCkeditor } from "src/hidden-ckeditor/index.tsx";

export const HiddenCkeditor = () => {
  // I mount this hidden ckeditor to utilize its editor instance for html normalization.
  // ckeditor automatically modifies incoming html
  // (wraps it in <p>, collapses spaces, trims whitespace, normalizes br, etc.)
  // If we skip this step and
  // give the raw backend HTML directly to React Hook Form, CKEditor will change
  // it on first render → the form becomes “dirty” even though the user did not
  // modify anything.

  return (
    <div
      style={{
        display: "none",
      }}
    >
      <CKEditor5
        onSetEditorRef={(editor) => {
          setCkeditor(editor);
        }}
      />
    </div>
  );
};
